import { ModelApiService } from './BaseApiService'

export default class CommentsApiService extends ModelApiService {
  constructor() {
    super('comments')
  }

  async getCommentsByCandidate(candidateId, params) {
    return await this.get(`candidate/${candidateId}`, params)
  }

  async getCommentTypes() {
    return await this.get('types')
  }

  async paginationRequest(url) {
    return await this.fetch('get', url)
  }

  async getAllCommentsForBooking(bookingId) {
    return await this.get(`booking/${bookingId}`)
  }
}
